export const themes = {
  headerLite: {
    thRoot: 'flex gap-10 items-center',
    thInner: 'flex flex-col md:flex-1 gap-5 items-start text-14 text-16 text-black',
    thName: 'flex font-brand gap-5 items-center leading-tight text-16 text-black truncate',
    thCountry: 'leading-tight order-first text-10 text-sienna truncate',
    thBack: '',
    thBadge: 'hidden',
  },
  cart: {
    thRoot: 'flex gap-10 items-center',
    thInner: 'flex flex-col md:flex-1 gap-5 items-start text-14 text-16 text-black',
    thName: 'flex font-brand gap-5 items-center leading-tight text-16 text-black truncate',
    thCountry: 'font-bold leading-tight order-first text-10 text-sienna truncate',
    thECBadge: 'hidden',
    thBack: 'hidden',
    thBadge: 'hidden',
  },
  teaser: {
    thInner: 'flex flex-col items-start text-black',
    thCountry: 'font-sans font-semibold text-sienna text-14',
    thName: 'flex-wrap font-sans font-semibold inline-flex gap-5 items-center order-last text-20',
    thECBadge: 'md:mx-5',
    thBack: 'hidden',
    thBadge:
      'bg-turquoise font-bold leading-1 px-10 py-5 rounded-pill shrink-0 text-10 text-center text-white whitespace-nowrap',
  },
};
